import Loading from '../../../common/loading/components/Loading';
import type { RebookingSearchType } from '../models';
import ErrorPage from '../../status-pages/components/ErrorPage';
import AvailableTripResults from './AvailableTripResults';

interface RebookingResultsSectionProps {
  isFetchingMore: boolean;
  rebookingSearchError: Error | null;
  isLoading: boolean;
  searchData: RebookingSearchType | null;
  handleFetchMoreFlights: () => Promise<void>;
  flightsOffset: number | null;
}

const RebookingResultsSection = ({
  isFetchingMore,
  rebookingSearchError,
  isLoading,
  searchData,
  handleFetchMoreFlights,
  flightsOffset,
}: RebookingResultsSectionProps) => {
  if (isLoading) {
    return <Loading dataTestId="search-loading" />;
  }

  if (rebookingSearchError) {
    return <ErrorPage />;
  }

  if (searchData) {
    return (
      <AvailableTripResults
        flightsOffset={flightsOffset}
        handleFetchMoreFlights={handleFetchMoreFlights}
        isLoadingMoreResults={isFetchingMore}
        search={searchData}
      />
    );
  }

  return null;
};

export default RebookingResultsSection;
